import { useQuery } from '@tanstack/react-query';
import { healthApi } from '@/api/health';

/**
 * Hook to fetch system health status with optional auto-refresh.
 * Pass `refetchInterval` in milliseconds to enable polling, or `false` to disable.
 */
export function useHealthStatus(refetchInterval: number | false = false) {
  return useQuery({
    queryKey: ['health'],
    queryFn: () => healthApi.getStatus(),
    refetchInterval,
    staleTime: 0, // Always consider data stale so we get fresh data
  });
}
